module.exports = __webpack_public_path__ + "static/media/sitevitrine.3876bc33.png";